import api from '../utils/api';

const vneidSdkService = {
  // Get SDK list with pagination
  getSdkList: async (params = {}) => {
    return api.get('/vneid-sdk', { params });
  },

  // Get SDK by ID
  getSdkById: async (id) => {
    return api.get(`/vneid-sdk/${id}`);
  },

  // Create new SDK (multipart/form-data)
  createSdk: async (formData) => {
    return api.post('/vneid-sdk', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Update SDK
  updateSdk: async (id, formData) => {
    return api.put(`/vneid-sdk/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Delete SDK
  deleteSdk: async (id) => {
    return api.delete(`/vneid-sdk/${id}`);
  },

  // Download SDK file
  downloadSdkFile: async (id, fileName) => {
    return api.download(`/vneid-sdk/${id}/download`, fileName);
  },

  // Get init data (methods, securities, statuses)
  getInit: async () => {
    return api.get('/vneid-sdk/init');
  },

  // Test SDK connection
  testConnection: async (key, version) => {
    return api.get('/vneid-sdk/connect', { key, version });
  },

  // Get SDK logs with pagination and filters
  getSdkLogs: async (params = {}) => {
    return api.get('/vneid-sdk/logs', params);
  },
};

export default vneidSdkService;
